<template>
  <div class="card">
    <work-experiences-view
      ref="workExperiencesView"
      title="Work Experiences"
      :acl="acl"
      :work-experiences-filter="userWorkExperiencesFilter"
      :work-experiences-columns="myWorkExperiencesColumns"
      :allow-add="true"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, toRefs, watch } from "vue";
import { BaseAclInterface } from "../../authentication/types";
import { myWorkExperiencesColumns } from "../_utils/tables";
import { WorkExperiencesFilterInterface } from "../types";
import WorkExperiencesView from "../_components/WorkExperiencesView.vue";

// Props
const props = defineProps({
  acl: { type: Object as () => BaseAclInterface, default: undefined },
  userId: { type: Number, default: undefined },
  tab: { type: String, default: undefined },
});

// Data properties
const { userId } = toRefs(props);
const userWorkExperiencesFilter = ref<WorkExperiencesFilterInterface>({ user_id: [userId.value] });
const workExperiencesView = ref<InstanceType<typeof WorkExperiencesView>>();

// Watchers
watch(
  () => props.tab,
  (newProp, oldProp) => {
    if (newProp === "workExperiences" && oldProp !== "workExperiences") {
      workExperiencesView.value?.refreshWorkExperiences();
    }
  }
);
</script>
